import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { ConfirmModal } from 'foundations-components/transitional/components/ConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const InvoiceVoidModal = props => {
  const {
    onConfirm,
    onReject,
    loading
  } = props;
  const title = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.components.modals.void.title"
  });
  const description = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.components.modals.void.description"
  });
  const confirmLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.components.modals.void.confirm"
  });
  const rejectLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.components.modals.void.reject"
  });
  return /*#__PURE__*/_jsx(ConfirmModal, {
    "data-test-id": "invoice-void-modal",
    size: "auto",
    message: title,
    description: description,
    confirmLabel: confirmLabel,
    rejectLabel: rejectLabel,
    confirmButtonProps: {
      loading
    },
    ConfirmButton: LoadingButton,
    onConfirm: onConfirm,
    onReject: onReject
  });
};
export default InvoiceVoidModal;